// extracted by mini-css-extract-plugin
export default {"container":"followBtn_container__EypTk","button":"followBtn_button__jgagx","followIcon":"followBtn_followIcon__V59Wx","lockIcon":"followBtn_lockIcon__syqf-"};